// import DataTransactionSumary from '../Components/DataTransactionSumary';
import { SeeAll } from './SeeAll';
import CardTransactionSummary from './CardTransactionSumary';

function TransactionSummary() {
  return (
    <div className=''>
      <SeeAll name='My Transactions' seeAll={true} />
      <CardTransactionSummary />
    </div>
  );
}
export default TransactionSummary;
